import React from 'react'
import Footer from '../Common/Footer'
import Header from '../Common/Header'
import MainBanner from './MainBanner'
import Contactus from '../Common/Contactus'

export const Logo_branding = () => {
  return (
    <>
    <Header />
    <MainBanner page="Logo & Branding Design" />
    <div id="subservice">
        <div className="container" >
            <div className="outer-bg">
                <div className="fleft text-center">
                    <img src={require("../../assets/images/joy.jpg")} alt="Profile Picture" className="profile-img" />
                    <h4>Vaibhav</h4>
                </div>
                <div className="fright features">
                    <div className="fleft btm-border feature-box">
                        <h3>2+</h3>
                        <p>Years of Experience</p>
                    </div>
                    <div className="fright btm-border feature-box">
                        <h3>$8</h3>
                        <p>Rate per Hour</p>
                    </div>
                    <div className="clearfix" />
                    <div className="fleft feature-box">
                        <h3>15,000+</h3>
                        <p>Total Hours</p>
                    </div>
                    <div className="fright feature-box">
                        <h3>50+</h3>
                        <p>Projects Completed</p>
                    </div>
                    <div className="clearfix" />
                </div>
                <div className="clearfix" />
                <div className="profile-about">
                    <div className="fleft w1">
                        <h5>About</h5>
                    </div>
                    <div className="fright w2">
                        <p>Logo & Branding Design involves creating a unique visual identity for a company or product, including the logo, color palette, and typography. It communicates the brand's values, personality, and mission. This design helps establish a memorable and consistent brand image across all marketing channels</p>
                    </div>
                </div>
                <div className="clearfix" />
                <div className="skills">
                    <div className="fleft w1">
                        <h5>Skills &amp; Tools</h5>
                    </div>
                    <div className="fright wl1 list">
                        <ul className="fleft">
                            <li> • Adobe Illustrator</li>
                            <li> • Adobe Photoshop</li>
                            <li> • CorelDRAW</li>
                            <li> • Affinity Designer</li>
                            <li> • Figma</li>
                            <li> • Canva for quick mockups</li>
                        </ul>
                        <ul className="fright wl2">
                            <li> • Visual storytelling</li>
                            <li> • Typography design</li>
                            <li> • Color theory</li>
                            <li> • Illustration </li>
                            <li> • Brand strategy</li>
                            <li> • Creative thinking</li>
                        </ul>
                    </div>
                    <div className="clearfix" />
                </div>
                <div className="project-showcase-title">
                    <h2 className="text-center"> <span className="text-primary">PROJECT</span><br /> SHOWCASE</h2>
                    <div className="sep-line" />
                </div>
                <div style={{
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: '110px',
  padding: '20px'
}}>
  {/* CHOTU APP */}
  <div style={{
    width: '22%',
    minWidth: '250px',
    backgroundColor: '#fff',
    borderRadius: '12px',
    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
    overflow: 'hidden',
    padding: '15px',
    textAlign: 'center',
    transition: 'transform 0.3s, box-shadow 0.3s',
    cursor: 'pointer'
  }}
    onMouseEnter={e => {
      e.currentTarget.style.transform = 'scale(1.05)';
      e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.2)';
    }}
    onMouseLeave={e => {
      e.currentTarget.style.transform = 'scale(1)';
      e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,0,0,0.1)';
    }}
  >
    <img src={require("../../assets/images/subservice/logo1.png")} alt="CHOTU APP" style={{
      width: '100%',
      borderRadius: '10px'
    }} />
    <p style={{ fontWeight: '700', fontSize: '1.1rem', marginTop: '12px', color: '#1e1e1e' }}>CHOTU APP</p>
    <p style={{ fontWeight: '500', fontSize: '0.95rem', color: '#444' }}>Logo & Branding</p>
  </div>
  {/* UTLITY */}
  <div style={{
    width: '22%',
    minWidth: '250px',
    backgroundColor: '#fff',
    borderRadius: '12px',
    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
    overflow: 'hidden',
    padding: '15px',
    textAlign: 'center',
    transition: 'transform 0.3s, box-shadow 0.3s',
    cursor: 'pointer'
  }}
    onMouseEnter={e => {
      e.currentTarget.style.transform = 'scale(1.05)';
      e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.2)';
    }}
    onMouseLeave={e => {
      e.currentTarget.style.transform = 'scale(1)';
      e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,0,0,0.1)';
    }}
  >
    <img src={require("../../assets/images/subservice/logo2.png")} alt="UTLITY" style={{
      width: '100%',
      borderRadius: '10px'
    }} />
    <p style={{ fontWeight: '700', fontSize: '1.1rem', marginTop: '12px', color: '#1e1e1e' }}>UTLITY</p>
    <p style={{ fontWeight: '500', fontSize: '0.95rem', color: '#444' }}>Logo & Branding</p>
  </div>

  {/* E-VYAPARI */}
  <div style={{
    width: '22%',
    minWidth: '250px',
    backgroundColor: '#fff',
    borderRadius: '12px',
    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
    overflow: 'hidden',
    padding: '15px',
    textAlign: 'center',
    transition: 'transform 0.3s, box-shadow 0.3s',
    cursor: 'pointer'
  }}
    onMouseEnter={e => {
      e.currentTarget.style.transform = 'scale(1.05)';
      e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.2)';
    }}
    onMouseLeave={e => {
      e.currentTarget.style.transform = 'scale(1)';
      e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,0,0,0.1)';
    }} 
    >
    <img src={require("../../assets/images/subservice/logo3.png")} alt="E-VYAPARI" style={{
      width: '100%',
      borderRadius: '10px'
    }} />
    <p style={{ fontWeight: '700', fontSize: '1.1rem', marginTop: '12px', color: '#1e1e1e' }}>E-VYAPARI</p>
    <p style={{ fontWeight: '500', fontSize: '0.95rem', color: '#444' }}>Logo & Branding</p>
  </div>
                </div>
                <br />
                <br />
               <div
  className="client-box"
  style={{
    padding: "40px 20px",
    backgroundColor: "#f9f9f9",
    fontFamily: "Arial, sans-serif",
  }}
>
  <div className="client-review" style={{ textAlign: "center", marginBottom: "40px" }}>
    <h2 style={{ fontSize: "32px", color: "#333", marginBottom: "10px" }}>
      What Clients Say
    </h2>
    <hr
      style={{
        width: "80px",
        border: "2px solid #5a5a5a",
        borderRadius: "2px",
        margin: "10px auto",
      }}
    />
  </div>

  <div
    className="client-review-box"
    style={{
      display: "flex",
      flexWrap: "wrap",
      gap: "20px",
      justifyContent: "center",
    }}
  >
    {[
      {
        img: require("../../assets/images/subservice/client.png"),
        name: "Jordan M.",
        title: "CEO, TechCorp",
        text: "Kirti transformed our website into a user-friendly experience.",
      },
      {
        img: require("../../assets/images/subservice/client2.png"),
        name: "Taylor S.",
        title: "Product Manager, Innovate Inc.",
        text: "Exceptional design skills and attention to detail.",
      },
      
      {
        img: require("../../assets/images/subservice/client4.png"),
        name: "Casey K.",
        title: "Founder, StartUp Hub",
        text: "Helped us achieve a seamless user experience.",
      },
    ].map((client, index) => (
      <div
        key={index}
        style={{
          width: "260px",
          backgroundColor: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          padding: "20px",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          cursor: "pointer",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.05)";
          e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.2)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.boxShadow = "0 4px 20px rgba(0, 0, 0, 0.1)";
        }}
      >
        <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
          <img
            src={client.img}
            alt="client"
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              objectFit: "cover",
              marginRight: "12px",
            }}
          />
          <div className="client-text">
            <p
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                margin: "0",
                color: "#333",
              }}
            >
              {client.name}
            </p>
            <p
              style={{
                fontSize: "14px",
                margin: "0",
                color: "#777",
                lineHeight: "1.4",
              }}
            >
              {client.title}
            </p>
          </div>
        </div>
        <div className="client-review-para">
          <p
            style={{
              fontSize: "14px",
              lineHeight: "1.6",
              color: "#555",
              margin: 0,
            }}
          >
            “{client.text}”
          </p>
        </div>
      </div>
    ))}
  </div>
</div>

               <div className="clearfix" />
                <div className="featured-projects feature-bg">
                    <div className="project-showcase-title">
  <h3 className="text-center" style={{ fontSize: '38px', lineHeight: '1.3' }}>
    <span className="text-primary">Featured</span> Projects
  </h3>
  <div className="sep-line" />
                
                        <div style={{
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: '55px',
  padding: '20px'
}}>
  {/* Snackstar */}
  <div style={{
    width: '25%',
    minWidth: '280px',
    backgroundColor: '#fff',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    overflow: 'hidden',
    padding: '20px',
    transition: 'transform 0.3s, box-shadow 0.3s',
    cursor: 'pointer',
    textAlign: 'center'
  }}
    onMouseEnter={e => {
      e.currentTarget.style.transform = 'scale(1.05)';
      e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.2)';
    }}
    onMouseLeave={e => {
      e.currentTarget.style.transform = 'scale(1)';
      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
    }}
  >
    <img src={require("../../assets/images/subservice/snackstar.png")} alt="snackstar" style={{
      width: '100%',
      height: 'auto',
      borderRadius: '10px'
    }} /> 
    <div style={{ marginTop: '15px' }}>
      <p style={{ fontSize: '20px', fontWeight: '700', color: '#1a1a1a' }}>E-commerce Website</p>
      <p style={{ fontSize: '16px', fontWeight: '500', color: '#444' }}>
        A responsive e-commerce website for a leading retail brand.
      </p>
      <a href="https://snackstar.in/" target="_blank" rel="noreferrer">
        <button style={{
          marginTop: '10px',
          padding: '8px 16px',
          fontSize: '15px',
          backgroundColor: '#8338DC                                                                                                                                                     ',
          color: '#fff',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer'
        }}>Shop Now</button>
      </a>
    </div>
  </div>

  {/* Shinezilla */}
  <div style={{
    width: '25%',
    minWidth: '280px',
    backgroundColor: '#fff',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    overflow: 'hidden',
    padding: '20px',
    transition: 'transform 0.3s, box-shadow 0.3s',
    cursor: 'pointer',
    textAlign: 'center'
  }}
    onMouseEnter={e => {
      e.currentTarget.style.transform = 'scale(1.05)';
      e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.2)';
    }}
    onMouseLeave={e => {
      e.currentTarget.style.transform = 'scale(1)';
      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
    }}
  >
    <img src={require("../../assets/images/subservice/shinezilla.jpg")} alt="shinezilla" style={{
      width: '100%',
      height: 'auto',
      borderRadius: '10px'
    }} />
    <div style={{ marginTop: '15px' }}>
      <p style={{ fontSize: '20px', fontWeight: '700', color: '#1a1a1a' }}>Mobile App</p>
      <p style={{ fontSize: '16px', fontWeight: '500', color: '#444' }}>
        An innovative mobile app for managing daily tasks.
      </p>
      <button style={{
        marginTop: '10px',
        padding: '8px 16px',
        fontSize: '15px',
        backgroundColor: '#8338DC',
        color: '#fff',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer'
      }}>View Project</button>
    </div>
  </div>

  {/* E-Vyapari */}
  <div style={{
    width: '25%',
    minWidth: '280px',
    backgroundColor: '#fff',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    overflow: 'hidden',
    padding: '20px',
    transition: 'transform 0.3s, box-shadow 0.3s',
    cursor: 'pointer',
    textAlign: 'center'
  }}
    onMouseEnter={e => {
      e.currentTarget.style.transform = 'scale(1.05)';
      e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.2)';
    }}
    onMouseLeave={e => {
      e.currentTarget.style.transform = 'scale(1)';
      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
    }}
  >
    <img src={require("../../assets/images/subservice/e_vyapari.png")} alt="e-vyapari" style={{
      width: '100%',
      height: 'auto',
      borderRadius: '10px'
    }} />
    <div style={{ marginTop: '15px' }}>
      <p style={{ fontSize: '20px', fontWeight: '700', color: '#1a1a1a' }}>Online Marketplace</p>
      <p style={{ fontSize: '16px', fontWeight: '500', color: '#444' }}>
        An online marketplace connecting local artisans with global customers.
      </p>
      <a href="https://evyapari.com/" target="_blank" rel="noreferrer">
        <button style={{
          marginTop: '10px',
          padding: '8px 16px',
          fontSize: '15px',
          backgroundColor: '#8338DC',
          color: '#fff',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer'
        }}>Shop Now</button>
      </a>
    </div>
  </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Contactus/>
    <Footer />
</>
  )
}